import { cls } from "@wss/cls";
import React, { ComponentProps, useEffect, useReducer } from "react";
import Category from "./components/Category";
import { reducer, initialState, withActions } from "./module";
import { SuperSimpleCarousel } from "@wss/carousel";
import { Icon } from "@clarkinc/zest-design-system/ui";
const PersonalizedCategoryContainer = ({
  className
}: ComponentProps<"div">) => {
  const [state, actions] = withActions(useReducer(reducer, initialState));
  useEffect(() => {
    actions.fetchRecommendations().then(result => console.log("do something with this result", result));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const items = state.categories.map(category => [<Category className="xl:mr-4 xl:last:mr-0" categoryName={category.categoryName} loading={state.loading} items={category.items} />, category.categoryName]);
  return <>
      <SuperSimpleCarousel className="container xl:hidden pb-6 xl:pb-10" data-sentry-element="SuperSimpleCarousel" data-sentry-source-file="PersonalizedCategoryContainer.tsx">
        <SuperSimpleCarousel.Previous className={cls("bg-white hover:bg-stone-50 border border-solid border-gray-300 rounded-[5px] shadow-sm h-10 w-10 absolute left-2-1/2 top-1/2 -translate-y-1/2", "focus-visible:border-2", "lz:left-10")} key={state.categories.length} data-sentry-element="unknown" data-sentry-source-file="PersonalizedCategoryContainer.tsx">
          <Icon name="ri-arrow-left-s-line" className="fill-green-500 w-6 h-6" data-sentry-element="Icon" data-sentry-source-file="PersonalizedCategoryContainer.tsx" />
        </SuperSimpleCarousel.Previous>
        <SuperSimpleCarousel.Content className="m-0" data-sentry-element="unknown" data-sentry-source-file="PersonalizedCategoryContainer.tsx">
          {items.map(([item, name]) => <SuperSimpleCarousel.Item key={name as string} className="mr-4 last:mr-0">
              {item}
            </SuperSimpleCarousel.Item>)}
        </SuperSimpleCarousel.Content>
        <SuperSimpleCarousel.Next className={cls("bg-white hover:bg-stone-50 border border-solid border-gray-300 rounded-[5px] shadow-sm h-10 w-10 absolute right-2-1/2 top-1/2 -translate-y-1/2", "focus-visible:border-2", "lz:right-10")} key={state.categories.length} data-sentry-element="unknown" data-sentry-source-file="PersonalizedCategoryContainer.tsx">
          <Icon name="ri-arrow-right-s-line" className="fill-green-500 w-6 h-6" data-sentry-element="Icon" data-sentry-source-file="PersonalizedCategoryContainer.tsx" />
        </SuperSimpleCarousel.Next>
      </SuperSimpleCarousel>
      <div className={cls("hidden",
    // hide when screen is smaller than 1024px - show carousel version instead
    "xl:flex", className)}>
        {items.map(([item]) => item)}
      </div>
    </>;
};
export default PersonalizedCategoryContainer;